import { getEffectiveTextWidthMm } from './labelTextFit';

export const minSize = type => ({ qr: [8, 8], image: [3, 3], line: [2, 0.2], rectangle: [2, 2] }[type] || [3, 2]);
export const clampPosition = (n, max) => Math.max(0, Math.min(max, Number(n) || 0));
export const clampSize = (n, min, max) => Math.max(Math.min(min, max), Math.min(max, Number(n) || min));
export const getFitScale = (availableWidth, availableHeight, width, height) => Math.max(0.2, Math.min(10, availableWidth / width, availableHeight / height));
export const screenToMm = (px, scale) => px / scale;
export const mmToScreen = (mm, scale) => mm * scale;
export const isElementOutsideCanvas = (el, layout) => el.x_mm < 0 || el.y_mm < 0 || el.x_mm + el.w_mm > layout.width_mm || el.y_mm + el.h_mm > layout.height_mm;
export function getElementCenterX(el, layoutWidthMm) {
  const width = Math.max(1, Number(layoutWidthMm) || 60);
  if (el?.type === 'static' || el?.type === 'dynamic') {
    // Text can render wider than w_mm in "expand" mode. Evaluate its width
    // from the left edge so the returned position is the actual center target.
    const renderedAtLeft = getEffectiveTextWidthMm({ ...el, x_mm: 0 }, width);
    return (width - renderedAtLeft) / 2;
  }
  return (width - (Number(el?.w_mm) || 20)) / 2;
}
export function normalizeElementGeometry(el, layout) {
  const [minW, minH] = minSize(el.type);
  const w = clampSize(el.w_mm, minW, layout.width_mm);
  const h = clampSize(el.h_mm, minH, layout.height_mm);
  const round = n => Math.round(n * 10) / 10;
  return { ...el, w_mm: round(w), h_mm: round(h), x_mm: round(clampPosition(el.x_mm, layout.width_mm - w)), y_mm: round(clampPosition(el.y_mm, layout.height_mm - h)) };
}
export function snapPosition(value, targets, threshold = 0.8) {
  const nearest = targets.reduce((best, target) => Math.abs(target - value) < Math.abs(best - value) ? target : best, Infinity);
  return Math.abs(nearest - value) <= threshold ? nearest : value;
}
